import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';
import { parseEnum } from '@/utils';


@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class AralKanepeUclu extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;

  product: ProductDefinition;

  seletedFoot: string = VirgoFoot.Krom;

  defHideObjects = [
    '_yyy',
    'aral_tekli_krom_ayak',
    'aral_tekli_siyah_boyali_ayak',
  ];

  defShowObjects = [
    'aral_uclu_yyy',
    'aral_uclu_krom_ayak_yyy',

  ];


  availableAnimations: AnimationDefinition[] = [];


  async created() {
    this.product = Store.getProductById('aral_kanepe_uclu');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);
    //this.availableAnimations = this.product.animations as any;
    //this.availableAnimationsChanged();

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });


    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color, element.palette, element.id);
      });
      if (Store.state.selection.foot === VirgoFoot.Krom)
      {
        await this.changeFoot(VirgoFoot.Krom);
      }
      if (Store.state.selection.foot === VirgoFoot.Boyali)
      {
        await this.changeFoot(VirgoFoot.Boyali);
      }
    } else {
      await this.applyDefaultSelection();
    }
  }


  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }



  mounted() {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection() {
    const selection = new AralSelection();
    selection.parts = [];
    selection.foot = VirgoFoot.Krom;

    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color, element.palette, element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
    await this.changeFoot(VirgoFoot.Krom);
  }


  async changeFoot(foot: VirgoFoot) {
    if (foot === VirgoFoot.Krom) {
      await this._configuratorService.hideObjects({ objects: ['aral_uclu_siyah_boyali_ayak_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['aral_uclu_krom_ayak_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.foot = VirgoFoot.Krom;
      this.seletedFoot = VirgoFoot.Krom;
    }
    if (foot === VirgoFoot.Boyali) {
      await this._configuratorService.hideObjects({ objects: ['aral_uclu_krom_ayak_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['aral_uclu_siyah_boyali_ayak_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.foot = VirgoFoot.Boyali;
      this.seletedFoot = VirgoFoot.Boyali;
    }
  }


  async colorChanged(color: any, palette: any, part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}

export class AralSelection {
  parts: PartSelection[];
  foot: VirgoFoot;
}
export class PartSelection {
  id: string;
  palette: string;
  color: string;
  name: string;
}


enum VirgoFoot {
  Krom = 'krom',
  Boyali = 'boyali',

}



// WEBPACK FOOTER //
// ./src/components/families/aralkanepe/AralKanepeUclu.ts